import { createRoute } from '@tanstack/react-router'

import { createValidateSearch } from '@campai/lib-web/routes'

import { rootRoute } from '@/product/community/root'
import { SearchSchema } from '@/product/community/category/routeUtils'

import { Topic } from './Topic'

export const topicRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/categories/$categoryId/topics/$topicId',
    component: Topic,
    validateSearch: createValidateSearch(SearchSchema),
})
